import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext"; 
import СoveredBackground from "../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../UI/ErrorMessage/ErrorMessage";
import Loader from "../UI/Loader/Loader";

 
const LoginPage = () => {
    
  const { login, loading } = useContext(AuthContext);

//   if(currentUser) navigate("/");

  const navigate = useNavigate();

  const [inputs, setInputs] = useState({
    iin: "",
    surname: "",
  });

  const [error, setError] = useState(null);

  useEffect(() => {document.title = "Авторизация"}, [])

  const handleChange = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      await login(inputs);
      navigate("/", {replace: true});
    } catch (err) {
      setError(err.response.data.message);
    }

  };

  

  
  return (
    <section className="login">

      <div className="container">
        <h1 className="login__text">Авторизация</h1>
        <div className="login__wrapper">
            {loading && <СoveredBackground><Loader/></СoveredBackground>}

            {error && <ErrorMessage message={error}/>}     

          <form
            method="post"
            action="/login"
            className="login__form"
            onSubmit={handleSubmit}
          >
            <div className="login__item">
              <label htmlFor="iin">Введите ИИН:</label>
              <input
                type="number"
                id="iin"
                name="iin"
                className="login__input"
                placeholder="ИНН"
                autoComplete="off"
                required
                onChange={handleChange}
              />
            </div>
            <div className="login__item">
              <label htmlFor="surname">Введите фамилию:</label>
              <input
                type="text"
                id="surname"
                name="surname"
                className="login__input"
                placeholder="Фамилия"
                autoComplete="off"
                required
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="login__wrapper__link">
              Войти
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default LoginPage;
